"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CalculatorIcon = exports.ArrowUpDownIcon = void 0;
var _react = _interopRequireDefault(require("react"));
const ArrowUpDownIcon = up => {
  return /*#__PURE__*/_react.default.createElement("i", {
    className: `icon-arrow-down ${up ? 'arrow-up' : ''}`
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: "24",
    height: "24",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fill: up ? '#006EFF' : '#000',
    transform: "rotate(-180 12.25 12.25)",
    d: "M12.5 10.8035221L17.6191093 16 19 14.5982389 12.5 8 6 14.5982389 7.3808907 16z",
    fillRule: "evenodd"
  })));
};
exports.ArrowUpDownIcon = ArrowUpDownIcon;
const CalculatorIcon = () => /*#__PURE__*/_react.default.createElement("svg", {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/_react.default.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 5H6V19H18V5ZM6.16667 4C5.52233 4 5 4.44772 5 5V19C5 19.5523 5.52233 20 6.16667 20H17.8333C18.4777 20 19 19.5523 19 19V5C19 4.44772 18.4777 4 17.8333 4H6.16667Z",
  fill: "black",
  fillOpacity: "0.6"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "8",
  y: "7",
  width: "8",
  height: "4",
  rx: "0.5",
  fill: "black",
  fillOpacity: "0.6"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "8",
  y: "12",
  width: "2",
  height: "2",
  rx: "0.5",
  fill: "black",
  fillOpacity: "0.6"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "8",
  y: "15",
  width: "2",
  height: "2",
  rx: "0.5",
  fill: "black",
  fillOpacity: "0.6"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "11",
  y: "12",
  width: "2",
  height: "2",
  rx: "0.5",
  fill: "black",
  fillOpacity: "0.6"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "11",
  y: "15",
  width: "2",
  height: "2",
  rx: "0.5",
  fill: "black",
  fillOpacity: "0.6"
}), /*#__PURE__*/_react.default.createElement("rect", {
  x: "14",
  y: "12",
  width: "2",
  height: "5",
  rx: "0.5",
  fill: "black",
  fillOpacity: "0.6"
}));
exports.CalculatorIcon = CalculatorIcon;